/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Compensation_LabelInputs */



/**
* | output |
* | --- |
* | "Timing Mode Compensation" |
*
* @param {Timing_Sync_Compensation_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_compensation_label = /** @type {((inputs?: Timing_Sync_Compensation_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Compensation_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compensation du mode de minutage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timing-Modus-Kompensation")
	if (locale === "it") return /** @type {LocalizedString} */ ("Compensazione della modalità di temporizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Компенсация режима синхронизации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Compensación del modo de temporización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时序模式补偿")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミングモード補正")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमिंग मोड मुआवजा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Compensação do Modo de Temporização")
	return /** @type {LocalizedString} */ ("Timing Mode Compensation")
});